<template>
  <div>
    <div class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-half">
            <h2 class="title" :style="'color:'+ titleColor">{{title}}</h2>
          </div>
          <div class="column is-half">
            <div class="has-sans-serif ">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['title', 'titleColor']
  }
</script>

<style scoped>
  .section {
    padding-bottom: 0;
  }
  p {
    margin-bottom: 1em;

  }
</style>